import Table from "@mui/material/Table";
import TableBody from "@mui/material/TableBody";
import TableCell from "@mui/material/TableCell";
import TableContainer from "@mui/material/TableContainer";
import TableHead from "@mui/material/TableHead";
import TableRow from "@mui/material/TableRow";
import Paper from "@mui/material/Paper";
import "./mainPage.css";
import { Button } from "@mui/material";
import { Link } from "react-router-dom";
import AppContext from "../../AppContext";
import React from "react";
import Box from "@mui/material/Box";
import Typography from "@mui/material/Typography";
import WhatsAppIcon from "@mui/icons-material/WhatsApp";
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";
import EmojiEventsIcon from "@mui/icons-material/EmojiEvents";
import RuleIcon from "@mui/icons-material/Rule";
import CategoryIcon from "@mui/icons-material/Category";
import {
  Accordion,
  AccordionSummary,
  AccordionDetails,
  List,
  ListItem,
  ListItemText,
} from "@mui/material";

const pdfFiles = [
  {
    category: "Minikler",
    pdfUrl:
      "https://firebasestorage.googleapis.com/v0/b/oyun-5302a.appspot.com/o/2022%2Fresult_pdfs%2FMinikler%20Kategorisi.pdf?alt=media&token=526ebaa8-7ab8-4fc6-8ca7-fd85264293c0",
  },
  {
    category: "Çocuklar",
    pdfUrl:
      "https://firebasestorage.googleapis.com/v0/b/oyun-5302a.appspot.com/o/2022%2Fresult_pdfs%2F%C3%87ocuklar%20Kategorisi.pdf?alt=media&token=1550520d-4bac-49ad-9925-d41a90415475",
  },
  {
    category: "Gençler",
    pdfUrl:
      "https://firebasestorage.googleapis.com/v0/b/oyun-5302a.appspot.com/o/2022%2Fresult_pdfs%2FGen%C3%A7ler%20Kategorisi.pdf?alt=media&token=9e3a2e3c-8090-4258-8beb-d68407a4d320",
  },
  {
    category: "Yetişkinler",
    pdfUrl:
      "https://firebasestorage.googleapis.com/v0/b/oyun-5302a.appspot.com/o/2022%2Fresult_pdfs%2FYeti%C5%9Fkinler%20Kategorisi.pdf?alt=media&token=d1269f3a-a2cb-4fae-99d0-a007a6ec7054",
  },
  {
    category: "Emektarlar",
    pdfUrl:
      "https://firebasestorage.googleapis.com/v0/b/oyun-5302a.appspot.com/o/2022%2Fresult_pdfs%2FEmektarlar%20Kategorisi.pdf?alt=media&token=89a5df78-8cd1-4682-a1de-dd3c212d2e7c",
  },
];

const resultsDiv = (
  <div className="resultsDiv">
    {/* <h1>
      <strong>OYUN 2022 Sanal Ödül Töreni</strong>
    </h1> */}
    <div className="iframeContainerContainer">
      <div className="iframeContainer">
        <iframe
          className="responsive-iframe"
          src="https://www.youtube.com/embed/o3Bo7FrR8Is"
          title="YouTube video player"
          frameBorder="0"
          allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
          allowFullScreen
        ></iframe>
      </div>
    </div>

    {/* <p>
      <strong>
        Bu sene 27.’si düzenlenen Türkiye Zeka Oyunları Yarışması “Oyun 2022”nin
        sonuçlarına aşağıdaki bağlantılardan ulaşabilirsiniz.
      </strong>
    </p> */}
    {/* <p>
      Final Sınavı'na katılan yarışmacıların puanlarına ve derecelerine
      aşağıdaki listelerden ulaşabilirsiniz. Dereceye giren yarışmacılara ödül
      için ayrıca e-posta ile bilgilendirme yapılacaktır.
    </p> */}

    <h3>SONUÇLAR</h3>
    <div
      style={{
        display: "flex",
        gap: "10px",
        justifyContent: "center",
        flexWrap: "wrap",
      }}
    >
      {pdfFiles.map((p) => {
        return (
          <a
            style={{ textDecoration: "none" }}
            key={p.category + "_pdf_link"}
            href={p.pdfUrl}
            target="_blank"
            rel="noreferrer"
          >
            <Button
              style={{
                backgroundColor: "white",
                textTransform: "none",
                width: 110,
              }}
              variant="outlined"
            >
              {p.category}
            </Button>
          </a>
        );
      })}
    </div>

    <p>
      Bu sene 27.’si düzenlenen Türkiye Zeka Oyunları Yarışması “Oyun 2022”nin
      sonuçları açıklanmıştır. Sanal ödül törenini 4 Ekim 2022 saat 20.00'den
      itibaren izleyebilirsiniz.
    </p>
  </div>
);

const bannerImage = (
  <img
    style={{ maxWidth: 630, width: "100%", borderRadius: 10 }}
    src="/assets/images/oyun-banner.jpg"
    alt="Oyun 2025 banner"
  />
);

const competitionCalendar = (
  <div>
    <h2>YARIŞMA TAKVİMİ</h2>

    <TableContainer
      component={Paper}
      sx={{ boxShadow: 3, borderRadius: 2 }}
      style={{ width: "100%", marginLeft: "auto", marginRight: "auto" }}
    >
      <Table
        sx={{
          minWidth: 650,
          backgroundColor: "#fdf7e3",
          borderRadius: "10px",
        }}
        size="medium"
        aria-label="exam schedule table"
      >
        <TableHead>
          <TableRow sx={{ backgroundColor: "#583b73" }}>
            <TableCell
              align="center"
              sx={{ color: "#fff", fontWeight: "bold" }}
            >
              SINAV
            </TableCell>
            <TableCell
              align="center"
              sx={{ color: "#fff", fontWeight: "bold" }}
            >
              AÇIKLAMA
            </TableCell>
            <TableCell
              align="center"
              sx={{ color: "#fff", fontWeight: "bold" }}
            >
              TARİH
            </TableCell>
          </TableRow>
        </TableHead>
        <TableBody>
          {[
            {
              name: "Kayıtlar",
              description: (
                <>
                  Kayıtlar <strong>20 Nisan 2026 Pazartesi</strong> günü 13.00’
                  te <strong>oyun.tzv.org.tr</strong> adresinde başlayacak ve{" "}
                  <strong>29 Temmuz 2026 Çarşamba günü</strong> 23.59’da sona
                  erecektir.
                </>
              ),
              date: "20 Nisan 2026 Pazartesi",
            },
            {
              name: "Birinci Aşama (Eleme) Sınavı",
              description: (
                <>
                  Eleme Sınavı,<strong> 20 Mayıs 2026, Çarşamba</strong> günü
                  saat 13.00'ten itibaren
                  <strong> oyun.tzv.org.tr </strong> adresinde yayınlanmaya
                  başlayacaktır. Yarışmacıya ait bilgiler ve cevaplar verdikleri
                  cevaplar en geç<strong> 29 Temmuz 2026, Çarşamba </strong>{" "}
                  günü 23.59'a <strong> oyun.tzv.org.tr </strong> adresinde yer
                  alan sınav ekranlarına girilecektir.
                </>
              ),
              date: "20 Mayıs 2026 Çarşamba - 29 Temmuz 2026 Çarşamba",
            },
            /*
            {
              name: "İkinci Aşama GriCeviz Turnuvası - %10",
              description: (
                <>
                  <strong>10-17 Eylül 2025</strong> tarihleri arasında, tüm
                  katılımcılar{" "}
                  <strong>
                    GriCeviz Bilişsel Beceri ve Zihinsel Gelişim Platformu'nu
                  </strong>{" "}
                  ücretsiz olarak kullanabileceklerdir. Bu aşamaya dair
                  ayrıntılı bilgilere yarışma sayfasından ulaşılabilir.
                </>
              ),
              date: "10 Eylül 2025 Pazartesi - 17 Eylül 2025 Çarşamba",
            },*/
            {
              name: "İkinci Aşama (Yarı Final) Sınavı",
              description: (
                <>
                  <strong>29 Ağustos 2026, Cumartesi </strong> günü, saat
                  13.00-14.30 arasında <strong>oyun.tzv.org.tr </strong>
                  adresi üzerinden çevrim içi olarak gerçekleştirilecektir.
                </>
              ),
              date: "29 Ağustos 2026 Cumartesi",
            },
            {
              name: "Final Sınavı ve Ödül Töreni",
              description: (
                <>
                  Yazılı sınav,<strong> 10 Ekim 2026, Cumartesi</strong> günü
                  Ankara’da ODTÜ Eğitim Fakültesi'nde 11.00-12.00 saatleri
                  arasında yazılı sınav olarak yapılacaktır. Yarı Final
                  Sınavında her kategoride ilk 100 dereceyi alanlar Final
                  Sınavına katılacaklardır. Minikler ve Çocuklar kategorisindeki
                  yarışmacılar, sınav sonrasında<strong> 12.10'da</strong>{" "}
                  sınıflardan çıkarılacaktır. Velilerin, yarışmacıları
                  karşılamak üzere<strong> 12.10'dan</strong> itibaren
                  sınıfların önünde bulunmaları gerekmektedir. Sınav bitiminde
                  sorulara/cevaplara itiraz etmek isterseniz sınav günü
                  <strong> saat 13.30'a</strong> kadar
                  <strong> oyun.tzv.org.tr </strong> üzerinden online itiraz
                  formunu doldurabilirsiniz. Ödül töreni aynı gün
                  <strong> saat 16.00'da</strong> ODTÜ Eğitim Fakültesi
                  Konferans Salonu'nda düzenlenecektir.
                </>
              ),
              date: "10 Ekim 2026 Cumartesi",
            },
          ].map((exam, index) => (
            <TableRow
              key={exam.name}
              sx={{
                backgroundColor: "#f9f4ff",
                "&:hover": { backgroundColor: "#e6dff1" },
              }}
            >
              <TableCell
                align="center"
                sx={{ fontWeight: "bold", color: "#582b71", fontSize: 15 }}
              >
                {exam.name}
              </TableCell>
              <TableCell
                align="center"
                sx={{ padding: "10px 20px", fontSize: 13 }}
              >
                {exam.description}
              </TableCell>
              <TableCell
                align="center"
                sx={{ fontWeight: "bold", color: "#000", fontSize: 15 }}
              >
                {exam.date}
              </TableCell>
            </TableRow>
          ))}
        </TableBody>
      </Table>
    </TableContainer>
  </div>
);

const conditions = (
  <Box
    sx={{
      width: "82%",
      margin: "auto",
      padding: 4,
      backgroundColor: "#f9f4ff",
      borderRadius: "12px",
      boxShadow: "0px 4px 12px rgba(0, 0, 0, 0.1)",
      border: "2px solid #582b71",
    }}
  >
    <Typography
      variant="h6"
      align="center"
      fontWeight="bold"
      sx={{
        color: "#582b71",
        marginBottom: 2,
      }}
    >
      🎯 Yarışma Bilgileri ve Koşullar
    </Typography>
    {/* Rules & Conditions */}
    <Accordion sx={{ borderRadius: "8px", marginTop: 1 }}>
      <AccordionSummary expandIcon={<ExpandMoreIcon />}>
        <CategoryIcon
          sx={{
            marginRight: 1,
            color: "#388e3c",
            marginTop: "auto",
            marginBottom: "auto",
          }}
        />
        <Typography fontWeight="bold" color="#582b71" fontSize={17}>
          Yarışma Kategorileri
        </Typography>
      </AccordionSummary>
      <AccordionDetails>
        <List
          sx={{
            fontSize: 8,
          }}
        >
          <ListItem>
            <ListItemText
              primary={<strong style={{ fontSize: "12px" }}>MİNİKLER</strong>}
              secondary="6-7-8 yaş (2020, 2019 ve 2018 yıllarında doğanlar. Okuma, yazma ve matematikte dört işlem becerisine sahip olmak gereklidir.)"
            />
          </ListItem>
          <ListItem>
            <ListItemText
              primary={<strong style={{ fontSize: "12px" }}>ÇOCUKLAR</strong>}
              secondary="9-10-11-12-13 yaş (2017, 2016, 2015, 2014, 2013 yıllarında doğanlar.)"
            />
          </ListItem>
          <ListItem>
            <ListItemText
              primary={<strong style={{ fontSize: "12px" }}>GENÇLER</strong>}
              secondary="14-15-16-17-18 yaş (2012, 2011, 2010, 2009, 2008 yıllarında doğanlar.)"
            />
          </ListItem>
          <ListItem>
            <ListItemText
              primary={
                <strong style={{ fontSize: "12px" }}>YETİŞKİNLER</strong>
              }
              secondary="19-49 yaş arası (2007, … , 1977 yıllarında doğanlar.)"
            />
          </ListItem>
          <ListItem>
            <ListItemText
              primary={<strong style={{ fontSize: "12px" }}>EMEKTARLAR</strong>}
              secondary="50 yaş ve üstü (1976 ve önceki yıllarda doğanlar.)"
            />
          </ListItem>
        </List>
      </AccordionDetails>
    </Accordion>
    {/* Rules & Conditions */}
    <Accordion sx={{ borderRadius: "8px", marginTop: 1 }}>
      <AccordionSummary expandIcon={<ExpandMoreIcon />}>
        <RuleIcon
          sx={{
            marginRight: 1,
            color: "#d32f2f",
            marginTop: "auto",
            marginBottom: "auto",
          }}
        />
        <Typography fontWeight="bold" color="#582b71" fontSize={17}>
          Kurallar ve Koşullar
        </Typography>
      </AccordionSummary>
      <AccordionDetails>
        <List
          sx={{
            fontSize: 15,
            "& .MuiListItem-root": {
              display: "block",
              py: 0.5,
              pl: "1.2em",
              textIndent: "-1.2em",
              textAlign: "left",
            },
          }}
        >
          <ListItem>
            &#8226; Yarışmaya oyun.tzv.org.tr adresi üzerinden kayıt olunacak ve
            gerekli bilgiler eksiksiz girilecektir. Yanlış bilgi verilmesi —
            hangi aşamada olursa olsun — diskalifiye sebebidir.
          </ListItem>
          <ListItem>
            &#8226; Yarışma kayıt ücreti <strong>800 TL</strong>'dir.
          </ListItem>
          <ListItem>
            &#8226; Eleme Sınavı sonuçlarına göre belirlenen başarı oranının
            üzerinde puan alan yarışmacılar Yarı Final’e katılmaya hak kazanır.
            Yarı Final Sınavı sonucunda ise her kategoride ilk 100’e giren
            yarışmacılar, Ankara’da gerçekleştirilecek yazılı Final Sınavına
            davet edilir.
          </ListItem>
          <ListItem>
            &#8226; Yarışmacılar, Birinci Aşama Sınavı sorularını belirtilen
            tarihler arasında, herhangi bir süre kısıtlaması olmaksızın tek
            başlarına çözerek sisteme gireceklerdir. Sorular cevaplanırken ara
            verilebilir, belirtilen süre içerisinde kaldığı yerden devam
            edilebilir veya önceden verilen cevaplar değiştirilebilir.
          </ListItem>
          <ListItem>
            &#8226; Her soru 10 puan değerindedir. Ayrıca, sorunun kategori
            bazında doğru çözülme yüzdesine (D) göre ek puan verilir. Bir
            sorudan alınacak puan <strong>10 + 10 x (1 - D/100)</strong> formülü
            ile hesaplanır. Buna göre bir soruyu doğru çözen yarışmacı oranı
            azaldıkça o sorudan alınacak puan artar.
          </ListItem>
          {/* <ListItem>
            &#8226; ikinci aşama 10 - 17 Eylül 2025 tarihleri arasında
            GriCeviz platformu üzerinden, üçüncü aşama ise 4 Ekim 2025 Cumartesi
            günü saat 13.00-14.15 arasında oyun.tzv.org.tr adresi üzerinden
            çevrimiçi olarak gerçekleştirilecektir. Sınav sonuçlarına göre
            aşağıdaki yüzdelik ağırlıklarla bir Genel Başarı Puanı
            hesaplanacaktır:
          </ListItem> 
          */}

          {/* <ListItem>
            <Box display="flex" flexDirection="column">
              <Typography
                sx={{
                  fontSize: 14,
                }}
              >
                Birinci Aşama Sınavı: %45
              </Typography>
              {<Typography
                sx={{
                  fontSize: 14,
                }}
              >
                İkinci Aşama GriCeviz Turnuvası: %10
              </Typography>}
              <Typography
                sx={{
                  fontSize: 14,
                }}
              >
                Üçüncü Aşama Sınavı: %45
              </Typography>
              <Typography variant="body2" sx={{ marginTop: 1, fontSize: 14 }}>
                <strong>Not:</strong> Hesaplama yapılırken her aşama için en
                yüksek puan alan yarışmacının puanı 100'e eşitlenecek şekilde
                oranlama yapılacak ve diğer yarışmacıların puanları bu orana
                göre belirlenecektir. Üç aşamanın puanları yukarıdaki yüzdelerle
                toplanacak ve genel başarı puanı hesaplanacaktır. Her kategoride
                en yüksek puanı alan 100, toplamda 500 yarışmacı, Final
                Sınavı’na katılmaya hak kazanacaktır.
              </Typography>
            </Box>
          </ListItem> */}
          <ListItem>
            &#8226; Yarışmanın son aşaması olan Final Sınavı, 10 Ekim 2026
            Cumartesi günü saat 11.00-12.00 arasında, Orta Doğu Teknik
            Üniversitesinde yazılı sınav olarak gerçekleştirilecektir.
            Yarışmacıların sınav saatinden bir saat önce sınav yerinde hazır
            bulunmaları ve sınav kurallarına eksiksiz uymaları gerekmektedir.
            Sınavın ardından ödül töreni düzenlenecektir.
          </ListItem>
          <ListItem>
            &#8226; Tüm sınav sonuçları yarışma sayfasında duyurulacak olup,
            katılım ve başarı belgelerine yine bu sayfa üzerinden erişilecektir.
          </ListItem>
          <ListItem>
            &#8226; İptal edilen soruların olması durumunda değerlendirmeler
            kalan sorular üzerinden yapılacak ve duyurulacaktır.
          </ListItem>
          <ListItem>
            &#8226; Yarışma soruları Emrehan Halıcı tarafından hazırlanmaktadır.
            Türkiye Zeka Vakfı’nın yazılı izni alınmadan yarışma soruları
            kullanılamaz, alıntı ya da uyarlama yapılamaz.
          </ListItem>
          <ListItem>
            &#8226; Türkiye Zeka Oyunları Yarışmalarında soruların çözümleri
            açıklanmamaktadır.
          </ListItem>
          <ListItem>
            &#8226; Yarışma sorularının kontrolünde ve itirazların
            değerlendirilmesinde TZV Soru Kurulu yetkilidir.
          </ListItem>
          <ListItem>
            &#8226; Türkiye Zeka Vakfı yarışma koşullarında ve takviminde
            değişiklik yapma hakkına sahiptir.{" "}
          </ListItem>
        </List>
      </AccordionDetails>
    </Accordion>
    {/* Awards */}
    <Accordion
      sx={{
        borderRadius: "8px",
        marginTop: 1,
      }}
    >
      <AccordionSummary expandIcon={<ExpandMoreIcon />}>
        <EmojiEventsIcon
          sx={{
            marginRight: 1,
            color: "#ffb300",
            marginTop: "auto",
            marginBottom: "auto",
          }}
        />
        <Typography fontWeight="bold" color="#582b71" fontSize={17}>
          Ödüller
        </Typography>
      </AccordionSummary>
      <AccordionDetails>
        <List
          sx={{
            fontSize: 15,
          }}
        >
          <ListItem>
            &#8226; Finale kalan 500 yarışmacıya bir yıllık GriCeviz Bilişsel
            Beceri ve Zihinsel Gelişim üyeliği verilecektir.
          </ListItem>
          <ListItem>
            &#8226; Her kategoride ilk 5 dereceye girenlere TZV Başarı Madalyası
            ve çeşitli ödüller verilecektir.
          </ListItem>
          <ListItem>Ayrıca;</ListItem>
          <ListItem>
            &#8226; Her kategoride ilk 10 dereceye girenler yarışma sayfasında
            “Şeref Kürsüsü”nde (fotoğrafları ve kısa özgeçmişleriyle birlikte)
            ilan edileceklerdir.
          </ListItem>
          <ListItem>
            &#8226; Yarışmaya katılan tüm katılımcılara Katılım Belgesi
            (elektronik) ,
          </ListItem>
          <ListItem>
            &#8226; Final sınavına katılmaya hak kazanan katılımcılara Başarı
            Belgesi (elektronik) ,
          </ListItem>
          <ListItem>
            &#8226; Final sınavında ilk 5 dereceye giren katılımcılara ise
            Derece Belgesi (elektronik) verilecektir.
          </ListItem>
        </List>
      </AccordionDetails>
    </Accordion>

    {/* Agreement Note */}
    <Typography
      variant="body1"
      sx={{ fontWeight: "bold", textAlign: "center", mt: 2 }}
    >
      ✅ Yarışmaya katılanlar bu koşulları kabul etmiş sayılırlar.
    </Typography>
  </Box>
);

const signUpButton = (
  <div style={{ marginTop: 15 }}>
    <Link to={"/signup"} style={{ textDecoration: "none" }}>
      <Button variant="contained" size="large" color="secondary">
        KAYIT OL
      </Button>
    </Link>
  </div>
);

const Whatsap = (
  <Box
    sx={{
      marginTop: 5,
      marginBottom: 5,
      padding: 3,
      backgroundColor: "#cbddcb",
      //  optional color for background #eefade
      borderRadius: 2,
      boxShadow: 2,
      textAlign: "center",
      maxWidth: 750,
      marginX: "auto",
    }}
  >
    <Typography variant="h6" sx={{ fontWeight: "bold", color: "#075e54" }}>
      📢 Önemli Duyuru!
    </Typography>
    <Typography sx={{ marginY: 1, color: "#333", fontSize: 14 }}>
      Tüm Oyun2026 duyuruları, hatırlatmalar, yaklaşan sınav tarihleri ve itiraz
      süreci gibi önemli açıklamalar, <strong>WhatsApp duyuru kanalı</strong>{" "}
      üzerinden yapılacaktır. Katılmak için aşağıdaki bağlantıya tıklayın!
    </Typography>

    <Button
      variant="contained"
      sx={{
        backgroundColor: "#02b849",
        color: "#fff",
        fontWeight: "bold",
        fontSize: 14,
        padding: "8px 12px",
        borderRadius: "8px",
        "&:hover": { backgroundColor: "#02b849" },
      }}
      href="https://whatsapp.com/channel/0029VabTkl305MUjehocPd0S"
      target="_blank"
      rel="noreferrer"
      startIcon={<WhatsAppIcon />}
    >
      WhatsApp Duyuru Kanalı
    </Button>

    <Typography variant="body2" sx={{ marginTop: 2, color: "#555" }}>
      📌 Kanala üye olduktan sonra kanal ayarlarından{" "}
      <strong>bildirimleri açmayı unutmayınız!</strong>
    </Typography>
  </Box>
);
function MainPage() {
  const { refreshUserData, setCentralState, user, activeProduct } =
    React.useContext(AppContext);

  // return <Year2023 />;

  return (
    <div className="main-body">
      <div>
        <h2>Türkiye 31. Zeka Oyunları Yarışması</h2>
        {/* {resultsDiv} */}
        {bannerImage}
        {competitionCalendar}
        {Whatsap}
        {conditions}
        {/* {!user && signUpButton} */}
      </div>
    </div>
  );
}

export default MainPage;
